// @flow

import { createContext } from 'react';

export type FieldMap = {
  [key: string]: any
};

type Context = {
  fields: FieldMap,
  setFields: (fields: FieldMap) => void,
  submit: () => void,
  isSubmitting: boolean
};

export const FormContext = createContext<Context>({
  fields: {},
  setFields: () => {},
  submit: () => {},
  isSubmitting: false
});
